export const pdfFont = ["Public Sans", "Noto Sans", "Noto Sans Arabic"];
